import React, { Component } from 'react';

import Spinner from '../../../../components/Spinner';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';


const easyFilter = [

	{	
		displayKey: '포함',
        displayName: '키워드 포함',
        test: function(filterValue, cellValue) {
          if (cellValue == null) return false;
          return cellValue.indexOf(filterValue) >= 0;
        },
    },
    {	
    	displayKey: '일치',
        displayName: '키워드 일치',
        test: function(filterValue, cellValue) {
          
          return filterValue == cellValue;
        },
    }

];

export default class BizAreaTable extends Component {

	constructor(props) {
		super(props);
		
		this.state = {
			tableData : this.props.bizAreaList,
			keyword : null
		}
	}

	componentDidMount(){    
		
	}

	componentWillReceiveProps = (nextProps) => {
		this.setState({
			tableData : nextProps.bizAreaList
		});
    }



	conditionalRowStyles = [
      {
        when: row => row.is_biz_area,
        style: {
          backgroundColor: '#dffaff !important',
          color: '#25d5f2 !important',
          cursor : "default"
        }
      },
    ];

    listColumn = [
		{
		    headerName: "영업지역",
		    field: "name",
		    sortable: true,
		    minWidth : 100,
		    resizable : true,
		    
		    cellClass: function(param) {return param.data.is_biz_area ? "text-center text-success" : "text-center text-danger" },
		    
        	cellRenderer : (param) => {
        		var result = param.value;
        		if(!param.data.is_biz_area) {
        			result = "<i class='fas fa-exclamation-circle'></i> " + result;
        		}
        		return result;
        	}
		},
		{
		    headerName: "전체",
		    field: "total",
		    sortable: true,
		    resizable : true,
		    cellClass: function(param) {return "text-center"}
		},
		{
		    headerName: "신규",
		    field: "new",
		    sortable: true,
		    resizable : true,
		    cellClass: function(param) {return "text-center"}
		},
		{
		    headerName: "재계약",
		    field: "renew",
		    sortable: true,
		    resizable : true,
		    cellClass: function(param) {return  "text-center"}
		}
		 
	];

	
	onGridReady = params => {
		this.gridApi = params.api;
    }


  onFirstDataRendered = params => {
    params.api.sizeColumnsToFit();
  }


    rowClick = (agGrid) => {
    	var selectedRows = this.gridApi.getSelectedRows();
    	var locCodes = [];
    	var names = [];
    	selectedRows.forEach(row => {
    		locCodes.push(row.id);
    		names.push(row.name);
    	});
    	
		this.props.rowClickCbFnc(locCodes, names);
	}



	render() {
		if (this.state.tableData== null) {
			return(
				<div className="card">
	                <div className="card-body" style={{height: this.props.height+ "px", textAlign:"center", paddingTop:"50px"}}>
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
	            </div>
			)
		} else {
			return(
				<div className="card">
	                <div className="card-body pb-0 pl-0 pr-0">
                		<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">{this.state.tableData.length} rows </div>
						<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 ag-theme-alpine"  style={{height: "400px", width:"100%", padding:"0px"}}>
							<AgGridReact
					          columnDefs={this.listColumn}
					          rowData={this.state.tableData}			
					          onGridReady={this.onGridReady}
					          rowSelection="multiple"
					          onFirstDataRendered={this.onFirstDataRendered.bind(this)}
					          onSelectionChanged={this.rowClick.bind(this)}
					          
					        >
					        </AgGridReact>
						</div>
	                    
	                </div>
	            </div>
			)
		}

	}

}
